import { render } from "./Correction.vue?vue&type=template&id=1114d0be&scoped=true"
import script from "./Correction.vue?vue&type=script&lang=js"
export * from "./Correction.vue?vue&type=script&lang=js"

import "./Correction.vue?vue&type=style&index=0&id=1114d0be&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1114d0be"]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QBtn});
